const mime = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export default function exportReportXlsx(fetchMssqlApi, endpoint, payload, onDone = () => {}) {
  fetchMssqlApi(
    endpoint,
    { method: "POST", hideNotification: false, showLoader: true, data: payload },
    (response) => {
      try {
        if (!response || !response.base64) throw new Error("Backend nie zwrócił pliku XLSX");
        const binary = window.atob(response.base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
        const url = URL.createObjectURL(new Blob([bytes], { type: mime }));
        const link = document.createElement("a");
        link.href = url;
        link.download = response.fileName || "Raport.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 30000);
      } catch (err) {
        console.error("Nie udało się zapisać eksportu XLSX:", err);
        window.alert("Nie udało się pobrać pliku Excel.");
      } finally {
        onDone();
      }
    },
    (err) => {
      console.error("Błąd eksportu raportu:", err);
      onDone();
    }
  );
}